"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DialogBackdropMotion", {
    enumerable: true,
    get: function() {
        return DialogBackdropMotion;
    }
});
const _reactmotioncomponentspreview = require("@fluentui/react-motion-components-preview");
const DialogBackdropMotion = _reactmotioncomponentspreview.FadeRelaxed;
